// context/UserContext.js
import { createContext, useEffect, useState } from "react";

export const UserContext = createContext();

function getInitialSession() {
    try {
        const stored = localStorage.getItem("userSession");
        return stored ? JSON.parse(stored) : { name: "", access_token: "" };
    } catch {
        localStorage.removeItem("userSession");
        return { name: "", access_token: "" };
    }
}

export const UserProvider = ({ children }) => {
    const [userSession, setUserSession] = useState(getInitialSession);

    useEffect(() => {
        if (userSession?.access_token) {
            localStorage.setItem("userSession", JSON.stringify(userSession));
        } else {
            localStorage.removeItem("userSession");
        }
    }, [userSession]);

    return (
        <UserContext.Provider value={{ userSession, setUserSession }}>
            {children}
        </UserContext.Provider>
    );
};
